var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15,
    r: 15,
    fill: "#F9DF1C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15,
    r: 15,
    fill: "#F9DF1C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1868 8.33301L14.2272 9.65532C12.6701 11.2531 11.5962 13.0713 11.1129 15.6608C12.2942 15.9914 13.3144 17.0933 13.3144 18.5809C13.3144 20.2889 11.972 21.6663 10.3075 21.6663C8.75038 21.6663 7.5154 20.5093 7.24693 18.636C6.70998 15.3854 9.12624 10.7022 12.1868 8.33301ZM21.7981 8.33301L23.8385 9.65532C22.2814 11.2531 21.2075 13.0162 20.7243 15.6608C21.9055 15.9914 22.9257 17.0933 22.9257 18.5809C22.9257 20.2889 21.5834 21.6663 19.9188 21.6663C18.3617 21.6663 17.1267 20.5093 16.8583 18.636C16.3213 15.3854 18.7376 10.7022 21.7981 8.33301Z",
    fill: "#203864"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.7f2166f74134b3e2c4087c8f4d964966.svg";
export { ForwardRef as ReactComponent };